var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0007 33.6666C7.79591 33.6666 0.333984 26.2047 0.333984 17C0.333984 7.79523 7.79591 0.333313 17.0007 0.333313C26.2054 0.333313 33.6673 7.79523 33.6673 17C33.6673 26.2047 26.2054 33.6666 17.0007 33.6666ZM17.0007 3.66665C9.63686 3.66665 3.66732 9.63618 3.66732 17C3.66732 24.3638 9.63686 30.3333 17.0007 30.3333C24.3644 30.3333 30.334 24.3638 30.334 17C30.334 9.63618 24.3644 3.66665 17.0007 3.66665ZM17.0014 8.26225C17.9219 8.26225 18.6681 9.00844 18.6681 9.92891V15.3333H24.0717C24.9922 15.3333 25.7384 16.0795 25.7384 17C25.7384 17.9205 24.9922 18.6666 24.0717 18.6666H18.6681V24.071C18.6681 24.9915 17.9219 25.7377 17.0014 25.7377C16.0809 25.7377 15.3347 24.9915 15.3347 24.071V18.6666H9.92958C9.00911 18.6666 8.26292 17.9205 8.26292 17C8.26292 16.0795 9.00911 15.3333 9.92958 15.3333H15.3347V9.92891C15.3347 9.00844 16.0809 8.26225 17.0014 8.26225Z",
    fill: "#CDD5DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0324a52211d0bf05be196ecdced034b4.svg";
export { ForwardRef as ReactComponent };